module.exports = __webpack_public_path__ + "img/btn_auto_start_on.c62148f3.jpg";